import { RIDE_ADMIN_DETAIL_CLOSE, RIDE_ADMIN_DETAIL_OPEN } from '../actions/rideAdmin';

const ACTION_HANDLERS = {
  [RIDE_ADMIN_DETAIL_OPEN]: (state, action) => ({ ...state, options: action.payload }),
  [RIDE_ADMIN_DETAIL_CLOSE]: state => ({ ...state, options: undefined }),
};

const initialState = {
  options: undefined,
};

const rideAdminReducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
};

export default rideAdminReducer;
